import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import Group from 'components/utils/Group'
import uuidV4 from 'lib/string/uuidV4Utils'
import BedbankRoomOptionRate from '../../BedbankRoomOptionRate'
import { pluralizeToString } from 'lib/string/pluralize'
import BodyText from 'LuxKit/Typography/BodyText'

const OptionsContainer = styled.div`
  padding: ${rem(12)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.default.eight};
`
interface Props {
  offer: App.BedbankOffer
  packageView: App.BedbankOfferPackageView
  roomPosition: number
}

function BedbankPackageOptionsModalTab(props: Props) {
  const { offer, packageView, roomPosition } = props

  const roomListId = useMemo(() => uuidV4(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [packageView])

  const rateListId = useMemo(() => uuidV4(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [packageView.effectiveRates])

  return (
    <Pane background="neutral-six">
      <Group direction="vertical" gap={8}>
        {packageView.effectiveRates.length > 1 && (
          <OptionsContainer>
            <BodyText variant="small" colour="neutral-three">{pluralizeToString('package option', packageView.effectiveRates.length)} available</BodyText>
          </OptionsContainer>
        )}
        {packageView.effectiveRates.map((rate, index) => <Pane key={rate.id}>
          <BedbankRoomOptionRate
            key={rate.id}
            rate={rate}
            offer={offer}
            roomListId={roomListId}
            packageView={packageView}
            optionNumber={index + 1}
            rateListId={rateListId}
            roomPosition={Math.max(roomPosition, 0) + 1}
            showOptionLabel={packageView.effectiveRates.length > 1}
          />
        </Pane>)}
      </Group>
    </Pane>
  )
}

export default BedbankPackageOptionsModalTab
